var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid pl-0 pr-0",
      attrs: { id: "visitor-history" },
    },
    [
      _c(
        "b-row",
        { attrs: { id: "visitor-history-row" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "start-date-input-group",
                    label: _vm.$t("message.first"),
                    "label-for": "start-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.startDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "start-date-input",
                      type: "datetime",
                    },
                    model: {
                      value: _vm.startDate,
                      callback: function ($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "end-date-input-group",
                    label: _vm.$t("message.last"),
                    "label-for": "end-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.endDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "end-date-input",
                      type: "datetime",
                    },
                    model: {
                      value: _vm.endDate,
                      callback: function ($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "query-input-group",
                    label: _vm.$t("message.query"),
                    "label-for": "query-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      id: "query-input",
                      placeholder: _vm.$t("message.query"),
                      name: "query",
                    },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "custom-input" },
            [
              _c("a-rate", {
                attrs: { "allow-clear": true },
                model: {
                  value: _vm.point,
                  callback: function ($$v) {
                    _vm.point = $$v
                  },
                  expression: "point",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-1 custom-input" },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      model: {
                        value: _vm.selectedUser,
                        callback: function ($$v) {
                          _vm.selectedUser = $$v
                        },
                        expression: "selectedUser",
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.allUsers")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.usersFilter.data, function (item) {
                        return _c(
                          "option",
                          { key: item._id, domProps: { value: item._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: { id: "query-input-group3" },
                },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      model: {
                        value: _vm.selectedCustomerDomains,
                        callback: function ($$v) {
                          _vm.selectedCustomerDomains = $$v
                        },
                        expression: "selectedCustomerDomains",
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.allSites")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.customerDomains, function (site) {
                        return _c(
                          "option",
                          { key: site, domProps: { value: site } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(site) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-excel-xlsx",
        {
          staticClass: "excel-style",
          attrs: {
            columns: _vm.getFields(),
            data: _vm.getExcellData(),
            filename: _vm.getFileName(),
            sheetname: "Sayfa 1",
          },
        },
        [_c("md-icon", [_vm._v("download")])],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        key: "vh-table-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: _vm.getCols(),
          dataSource: _vm.visitors.data,
          loading: _vm.loading,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.customLoginInputs, function (input, i) {
              return {
                key: input._id,
                fn: function (data) {
                  return _c("div", { key: i, staticClass: "ellipsis" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getInputValue(data, input)) +
                        "\n        "
                    ),
                  ])
                },
              }
            }),
            {
              key: "_country",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        item.geoLocation ? item.geoLocation.country : "N/A"
                      ) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_createdDate",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("dateShorted")(item.createdDate)) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_destroyedDate",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("dateShorted")(item.destroyedDate)) +
                      "\n        "
                  ),
                ])
              },
            },
            {
              key: "_timeSpent",
              fn: function (data, item) {
                return _c(
                  "div",
                  {},
                  [
                    _c("PassedTimeCounterTimeFormat", {
                      attrs: {
                        date: item.connectedDate,
                        endDate: item.destroyedDate,
                      },
                    }),
                  ],
                  1
                )
              },
            },
            {
              key: "_star",
              fn: function (data, item) {
                return _c("div", {}, [
                  _vm._v(
                    "\n            " + _vm._s(item.point || "-") + "\n        "
                  ),
                ])
              },
            },
            {
              key: "_user",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                      }",
                      },
                    ],
                    attrs: { content: _vm.getUserNames(item) },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getUserNames(item).length > 15
                            ? _vm.getUserNames(item).slice(0, 11) + "..."
                            : _vm.getUserNames(item)
                        ) +
                        "\n        "
                    ),
                  ]
                )
              },
            },
            {
              key: "_actions",
              fn: function (data, item) {
                return _c(
                  "div",
                  {},
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton d-flex align-items-center",
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.view(item._id, item.index)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "3px",
                              display: "block",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.detail")))]
                        ),
                        _vm._v(" "),
                        _c("SearchIcon"),
                      ],
                      1
                    ),
                  ],
                  1
                )
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      "undefined" !== typeof _vm.selectedHistory.visitor._id
        ? _c(
            "b-modal",
            {
              attrs: {
                id: "history-details",
                title: _vm.$t("message.historyDetails"),
                centered: "",
                "hide-footer": "",
              },
              on: { hidden: _vm.reset },
            },
            [
              _c(
                "b-tabs",
                { attrs: { "content-class": "mt-3" } },
                [
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("message.chat"), active: "" } },
                    [
                      _vm.filteredMessages.length
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                              },
                            },
                            [
                              _c(
                                "vue-excel-xlsx",
                                {
                                  staticClass: "md-button",
                                  staticStyle: {
                                    "justify-self": "end",
                                    width: "36px",
                                    "align-self": "center",
                                  },
                                  attrs: {
                                    columns: _vm.downloadConversationFields(),
                                    data: _vm.downloadConversationData(),
                                    filename: _vm.downloadConversationName,
                                    sheetname: "Page 1",
                                  },
                                },
                                [_c("md-icon", [_vm._v("download")])],
                                1
                              ),
                              _vm._v(" "),
                              _vm.filteredMessages.length
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "chat-scroll",
                                          rawName: "v-chat-scroll",
                                        },
                                      ],
                                      staticClass: "messages",
                                    },
                                    [
                                      _c("MessageList", {
                                        attrs: {
                                          "always-scroll-to-bottom": false,
                                          colors: _vm.colors,
                                          messages: _vm.getMessages(),
                                          participants: _vm.getParticipants(),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "b-alert",
                                { attrs: { show: "", variant: "info" } },
                                [_vm._v(_vm._s(_vm.$t("message.chatNotFound")))]
                              ),
                            ],
                            1
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedHistory.visitor.visitor
                    ? _c(
                        "b-tab",
                        { attrs: { title: _vm.$t("message.visitorInfo") } },
                        [
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.fullName")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "userInfo sec",
                                attrs: {
                                  content: _vm.selectedHistory.visitor.fullname,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.selectedHistory.visitor.fullname
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.email")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                  },
                                ],
                                staticClass: "userInfo sec",
                                attrs: {
                                  content: _vm.selectedHistory.visitor.email,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.selectedHistory.visitor.email) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v("IP"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.ipAddress || "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.getSubjectName(
                            _vm.selectedHistory.visitor.subject
                          )
                            ? _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("message.department")) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.getSubjectName(
                                          _vm.selectedHistory.visitor.subject
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(_vm._s(_vm.$t("message.visitingPage"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.visitor
                                      .visitingPage || "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.country")) +
                                  " & " +
                                  _vm._s(_vm.$t("message.city"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.geoLocation
                                      .country ||
                                      _vm.selectedHistory.visitor.visitor
                                        .country
                                  ) +
                                  "\n                        -\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.visitor.city ||
                                      "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.browser")) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.visitor
                                      .browser || "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(_vm._s(_vm.$t("message.os"))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.selectedHistory.visitor.visitor.os ||
                                      "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.$_.get(
                            _vm.selectedHistory,
                            "visitor.note.representativeNote",
                            false
                          )
                            ? _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(_vm._s(_vm.$t("message.feedback"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.selectedHistory.visitor.note
                                          .representativeName
                                      ) +
                                      ":" +
                                      _vm._s(
                                        _vm.selectedHistory.visitor.note
                                          .representativeNote
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "flex-end",
            "margin-top": "6px",
          },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              pageSizes: _vm.pageSizes,
              total: _vm.visitors.total,
              pageSizeLocalStorageKey: "visitor-history-page-size",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }